function getTime() {
  const today = new Date()
  const mm = String(today.getMinutes()).padStart(2, "0")
  const hh = String(today.getHours()).padStart(2, "0")
  return 24 * 60 - (hh * 60 + +mm)
}
export default getTime
